<template>
  <div class="flex flex-col place-content-center">
    <div class="flex flex-col gap-2">
      <h2 class="text-5xl font-bold leading-[3.5rem] tracking-[-0.04rem] text-neutral-800">
        {{ t('auth.setup_mfa.title') }}
      </h2>
      <p class="text-[1.125rem] font-semibold leading-[1.4375rem] tracking-[-0.02rem] text-neutral-500">
        {{ t('auth.setup_mfa.under_title') }}
      </p>
    </div>

    <form class="mt-12 flex w-[29.625rem] flex-col place-content-center gap-2" @submit.prevent="onSubmit">
      <infuse-field :label="t('auth.setup_mfa.description')">
        <div class="justify-left flex items-center gap-4">
          <QRCodeVue3
            :value="qrCodeUrl"
            :dots-options="{
              type: 'extra-rounded',
              color: '#000000'
            }"
          />
        </div>

        <infuse-field :label="t('auth.setup_mfa.description_text_code')" />
        <div class="justify-left flex items-center gap-4">
          <infuse-tag
            variant="primary"
            size="base"
            class="flex flex-row items-center items-stretch rounded-lg bg-neutral-50 text-neutral-500"
          >
            {{ sharedSecret }}
          </infuse-tag>
          <InfuseCopy v-slot="scope">
            <font-awesome-icon
              class="ml-1 cursor-pointer text-neutral-500 hover:text-neutral-600"
              :icon="['far', 'copy']"
              @click="scope.copy(sharedSecret)"
            />
          </InfuseCopy>
        </div>
      </infuse-field>

      <infuse-field :label="t('auth.setup_mfa.enter_code')" />

      <infuse-field :label="t('auth.setup_mfa.otp')">
        <infuse-input
          v-model="form.otp"
          type="text"
          :placeholder="t('auth.setup_mfa.otp')"
          :tabindex="1"
          required
          autofocus
        />
      </infuse-field>

      <div class="flex items-center justify-end gap-4">
        <infuse-button size="large" :loading="loading" type="submit" :tabindex="3">
          {{ t('auth.setup_mfa.submit') }}
        </infuse-button>
      </div>
    </form>
  </div>
</template>

<script lang="ts" setup>
import { InfuseButton, InfuseCopy, InfuseField, InfuseInput, InfuseTag } from '@infuse/ui/components';
import { reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import QRCodeVue3 from 'qrcode-vue3';

interface Props {
  loading?: boolean;
  sharedSecret: string;
  qrCodeUrl: string;
}

interface Emits {
  (e: 'submit', form: { otp: string }): void;
}

defineProps<Props>();
const emit = defineEmits<Emits>();

const { t } = useI18n();

const form = reactive({
  otp: ''
});

function onSubmit() {
  emit('submit', form);
}
</script>
